// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.clickable[data-v-71f6a060] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
